import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px 19px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;
